import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DiTextViewComponent} from 'app/common/di-views/components/di-text-view/di-text-view.component';
import {NzTooltipModule} from 'ng-zorro-antd/tooltip';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {DiDateTimeViewComponent} from 'app/common/di-views/components/di-date-time-view/di-date-time-view.component';
import {DiStringDateTimeViewComponent} from 'app/common/di-views/components/di-string-date-time-view/di-string-date-time-view.component';
import {DiColorViewComponent} from 'app/common/di-views/components/di-color-view/di-color-view.component';
import {DiBooleanViewComponent} from 'app/common/di-views/components/di-boolean-view/di-boolean-view.component';
import {DiArrayViewComponent} from 'app/common/di-views/components/di-array-view/di-array-view.component';

@NgModule({
    declarations: [
        DiTextViewComponent,
        DiDateTimeViewComponent,
        DiStringDateTimeViewComponent,
        DiColorViewComponent,
        DiBooleanViewComponent,
        DiArrayViewComponent
    ],
    imports: [CommonModule, NzTooltipModule, FontAwesomeModule],
    exports: [
        DiTextViewComponent,
        DiDateTimeViewComponent,
        DiStringDateTimeViewComponent,
        DiColorViewComponent,
        DiBooleanViewComponent,
        DiArrayViewComponent
    ],
    providers: []
})
export class DiViewsModule {}
